import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import storyEn from '../story/story-en.json'
import storyTr from '../story/story-tr.json'
import storyDe from '../story/story-de.json'
import storyFr from '../story/story-fr.json'
import storyEs from '../story/story-es.json'
import storyIt from '../story/story-it.json'
import storyMs from '../story/story-ms.json'
import storyHi from '../story/story-hi.json'
import storyAr from '../story/story-ar.json'
import storyFa from '../story/story-fa.json'
import storyUr from '../story/story-ur.json'
import storyCkb from '../story/story-ckb.json'
import storyKu from '../story/story-ku.json'

export const RTL_LANGUAGES = ['ar', 'fa', 'ckb', 'ur']

const resources = {
  en: { translation: { story: storyEn } },
  tr: { translation: { story: storyTr } },
  de: { translation: { story: storyDe } },
  fr: { translation: { story: storyFr } },
  es: { translation: { story: storyEs } },
  it: { translation: { story: storyIt } },
  ms: { translation: { story: storyMs } },
  hi: { translation: { story: storyHi } },
  ar: { translation: { story: storyAr } },
  fa: { translation: { story: storyFa } },
  ur: { translation: { story: storyUr } },
  ckb: { translation: { story: storyCkb } },
  ku: { translation: { story: storyKu } },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
      checkWhitelist: true
    }
  })

export default i18n 